var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { map } from 'rxjs/operators';
export function createHttpProxyLoader(proxy) {
    return function httpProxyLoader(modelValue, loadPayload) {
        return proxy
            .load(null, __assign(__assign({}, modelValue), loadPayload.params), loadPayload.filterQuery)
            .pipe(map(function (value) { return ({
            data: value.data,
            meta: { totalCount: value.meta.totalCount, status: value.meta.status }
        }); }));
    };
}
//# sourceMappingURL=loader.js.map